import { EMPTY_LIST } from '../../../constants/common'
import { useDateLocale, useTimeZone } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { QA_NAME_CALENDAR_GRID } from '../CalendarGrid.constants'
import {
  getCalendarGridAllDayItems,
  getCalendarGridItemsByDay,
} from '../CalendarGrid.utils'

import { useCalendarGridWeekSelection } from './CalendarGridWeek.hooks'
import {
  getCalendarGridFirstHour,
  getCalendarGridHourLabels,
  getCalendarGridWeekItemsByDay,
  getCalendarGridWeekStyle,
} from './CalendarGridWeek.utils'
import { CalendarGridWeekAllDay } from './CalendarGridWeekAllDay'
import { CalendarGridWeekColumn } from './CalendarGridWeekColumn'
import { CalendarGridWeekHead } from './CalendarGridWeekHead'
import { CalendarGridWeekHours } from './CalendarGridWeekHours'

import * as styles from './CalendarGridWeek.module.css'

function CalendarGridWeek({
  canMoveItems,
  canMoveItemsInTime,
  dayLoads,
  days,
  items,
  now,
  previewItem,
  today,
  onClickEmptyCell,
  onClickItem,
  onClickSecondaryLabel,
  onSelectEmptyDays,
  onSelectEmptyRange,
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const {
    handleClickCell,
    handlePointerDownCell,
    handlePointerMoveCell,
    isSelecting,
    selectionItem,
  } = useCalendarGridWeekSelection({
    onClickCell: onClickEmptyCell,
    onSelectRange: onSelectEmptyRange,
  })

  const firstHour = getCalendarGridFirstHour({ items, locale, timezone })

  const hours = getCalendarGridHourLabels(firstHour)

  const { itemsByDay, outsideHoursItemsByDay } = getCalendarGridWeekItemsByDay({
    firstHour,
    items,
    locale,
    timezone,
  })

  return (
    <div
      {...getQaSelector({ value: QA_NAME_CALENDAR_GRID })}
      className={styles.CalendarGridWeek}
      style={getCalendarGridWeekStyle(days)}
    >
      <CalendarGridWeekHead
        dayItemsByDay={getCalendarGridItemsByDay({ items, locale, timezone })}
        dayLoads={dayLoads}
        days={days}
        outsideHoursItemsByDay={outsideHoursItemsByDay}
        today={today}
        onClickItem={onClickItem}
        onClickSecondaryLabel={onClickSecondaryLabel}
      />
      <CalendarGridWeekAllDay
        canMoveItems={canMoveItems}
        dayLoads={dayLoads}
        days={days}
        items={getCalendarGridAllDayItems(items)}
        today={today}
        onClickItem={onClickItem}
        onClickSecondaryLabel={onClickSecondaryLabel}
        onSelectDays={onSelectEmptyDays}
      />
      <CalendarGridWeekHours hours={hours} />
      {days.map(day => (
        <CalendarGridWeekColumn
          canMoveItemsInTime={canMoveItemsInTime}
          day={day}
          days={days}
          firstHour={firstHour}
          hours={hours}
          items={itemsByDay[day.date] ?? EMPTY_LIST}
          key={day.date}
          now={now}
          previewItem={previewItem ?? selectionItem}
          today={today}
          onClickEmptyCell={onClickEmptyCell ? handleClickCell : undefined}
          onClickItem={onClickItem}
          onClickSecondaryLabel={onClickSecondaryLabel}
          onPointerDownCell={
            onSelectEmptyRange ? handlePointerDownCell : undefined
          }
          onPointerMoveCell={isSelecting ? handlePointerMoveCell : undefined}
        />
      ))}
    </div>
  )
}

export default CalendarGridWeek
